import { BarChart, XAxis, YAxis, Bar, ResponsiveContainer, Cell, Tooltip } from "recharts";

export default function CenterBarChart({ data = [] }) {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
      >
        <XAxis
          dataKey="displayName"
          tick={{ fill: "#fff", fontSize: 12 }}
          axisLine={{ stroke: "rgba(255,255,255,0.3)" }}
          tickLine={false}
          dy={10}
        />
        <YAxis hide />
        <Tooltip
          cursor={{ fill: "transparent" }}
          contentStyle={{
            backgroundColor: "#001b0e",
            border: "1px solid rgb(252, 68, 32)",
            borderRadius: "8px",
            color: "#fff",
          }}
          itemStyle={{ color: "#fff" }}
        />
        <Bar dataKey="value" barSize={50} radius={[4, 4, 0, 0]}>
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.fill || "rgb(252, 68, 32)"} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
